var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "history-chat-list" },
    _vm._l(_vm.chatListData, function (item, index) {
      return _c("div", { key: index, staticClass: "question-answer" }, [
        _c(
          "div",
          { staticClass: "question-item" },
          [
            _c("p", [_vm._v(_vm._s(item.question))]),
            item.type === 1
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: "专家查询",
                      placement: "top",
                      "popper-class": "hover-popper",
                    },
                  },
                  [
                    _c("scholarIcon", {
                      attrs: { width: "30px", height: "30px", fill: "#666" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            item.type === 2
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: "技术问答",
                      placement: "top",
                      "popper-class": "hover-popper",
                    },
                  },
                  [
                    item.type === 2
                      ? _c("questionIcon", {
                          attrs: { width: "22", height: "22", fill: "#666" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            item.type === 3
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: "文献调研",
                      placement: "top",
                      "popper-class": "hover-popper",
                    },
                  },
                  [
                    item.type === 3
                      ? _c("literatureIcon", {
                          attrs: { width: "14", height: "14", fill: "#666" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "answer-item" }, [
          _c("div", { staticClass: "avatar" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/common/ai-answer.png"),
                alt: "",
              },
            }),
          ]),
          _c("div", { staticClass: "answer-con" }, [
            item.type === 3 && item.answer === "文献综述已生成完毕，点击下载"
              ? _c("div", { staticClass: "answer-text download-literature" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.downloadLiterature(item.task_id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.answer))]
                  ),
                ])
              : _c("div", { staticClass: "answer-text" }, [
                  item.type !== 2
                    ? _c(
                        "div",
                        [
                          item.thinking
                            ? _c(
                                "toggle-component",
                                { attrs: { "default-visible": true } },
                                [
                                  _c("div", {
                                    staticClass: "thinking-con",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.sanitizeHTML(item.thinking)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c("div", {
                            staticStyle: { "white-space": "normal" },
                            domProps: {
                              innerHTML: _vm._s(_vm.sanitizeHTML(item.answer)),
                            },
                          }),
                        ],
                        1
                      )
                    : _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.isTranslated
                                ? item.translatedValue
                                : item.answer
                            ) +
                            " "
                        ),
                      ]),
                ]),
          ]),
        ]),
        (item.scholar_card && item.scholar_card.length) ||
        (item.type === 2 && _vm.isNotEmptyObject(item.refs))
          ? _c(
              "div",
              {
                staticClass: "flex operate-btn",
                staticStyle: { height: "30px" },
              },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: "复制",
                      placement: "top",
                      "popper-class": "hover-popper",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "24px",
                        height: "24px",
                        "margin-top": "-2px",
                        cursor: "pointer",
                      },
                      attrs: {
                        src: require("@/assets/images/common/copy-icon.png"),
                        alt: "copy",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopyAnswer(item)
                        },
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      display: "flex",
                      "justify-content": "flex-end",
                    },
                  },
                  [
                    item.scholar_card && item.scholar_card.length
                      ? _c(
                          "span",
                          {
                            staticClass: "look-infor",
                            on: {
                              click: function ($event) {
                                return _vm.viewCardData("scholar", index)
                              },
                            },
                          },
                          [_vm._v("查看来源专家")]
                        )
                      : _vm._e(),
                    item.type === 2 && _vm.isNotEmptyObject(item.refs)
                      ? _c(
                          "span",
                          {
                            staticClass: "look-infor",
                            on: {
                              click: function ($event) {
                                return _vm.viewCardData("paper", index)
                              },
                            },
                          },
                          [_vm._v("查看参考文献")]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }